import { createElement as rc, useMemo } from 'react';
import PropTypes from 'prop-types';
import { View, Button, h4, fromTheme, styled, webOnlyStyles } from 'lib_ui-primitives';
import { useTheme } from 'styled-components';
import HNode from '../../HNode';
import createTreePositionGetter from '../../utilities/createTreePositionGetter';

const ListRow = styled(View).attrs({ name: 'list-row' })`
    background-color: ${fromTheme('backgroundColor')};
    padding: ${fromTheme('viewPadding')};
    margin-bottom: ${fromTheme('viewMargin')};
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;

    div[name='form-field'] {
        min-width: 200px;
    }
`;

const ListSubForm = styled(View).attrs({ displayName: 'list-subform' })`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const LeftToRight = styled(View)`
    flex-grow: 1;
    width: 100%;
    flex-shrink: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

const Title = styled(h4)`
    margin: ${fromTheme('viewMargin')};
`;

let RemoveButton = styled(Button)`
    margin: 0;
`;
RemoveButton = webOnlyStyles(RemoveButton)`
    &:hover {
        margin: 0 !important;
    }
`;

function WorkflowActionPane(props) {
    const {
        hNode: { propertyPath, title, children, treePosition },
        value,
        onRemove,
        childIndex,
        currentRoute
    } = props;
    const theme = useTheme();

    function subFormRemove() {
        onRemove(childIndex);
    }

    const getTreePosition = useMemo(
        () => createTreePositionGetter(treePosition, children.length),
        [children.length, treePosition]
    );

    // use a stringified children to deep compare instead of relying on reference
    const childrenString = JSON.stringify(children);
    const memoizedChildHNodes = useMemo(() => {
        return children.map((hNode, index) => {
            const id = `${hNode.id}_${childIndex}`;
            const treePosition = getTreePosition(index);
            return {
                ...hNode,
                id,
                treePosition,
                propertyPath
            };
        });
        // use stringified children instead of reference
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [childrenString, childIndex, getTreePosition]);

    // prettier-ignore
    return rc(ListRow, null,
        rc(LeftToRight, null,
            rc(Title, null, title),
            rc(RemoveButton, {icon: 'clear', size: 'sm', buttonStyle: 'round', color: 'transparent', fontColor:theme.icon.error, onClick: subFormRemove})
        ),
        rc(ListSubForm, null,
            memoizedChildHNodes.map((hNode, index) =>
                rc(HNode, {
                    key: index,
                    hNode,
                    currentRoute
                }, value[hNode.propertyName])
            )
        )
    );
}

WorkflowActionPane.propTypes = {
    hNode: PropTypes.shape({
        treePosition: PropTypes.shape({
            sequence: PropTypes.number.isRequired
        }).isRequired
    }).isRequired
};

export default WorkflowActionPane;
